import { FORM_ERROR } from 'final-form'
import React from 'react'
import { Form } from 'react-final-form'

import { Primary } from '@cinch/oxd-components/button/src'
import Panel from '@cinch/oxd-components/panel/src'
import { WbacService } from '@cinch/oxd-utils/requests/src'
import * as Storage from '@cinch/oxd-utils/storage/src'

import SEO from '../../../../../apps/www/src/components/seo'
import Damage from '../../components/damage/damage.component'
import buildInitialValues from '../../components/journey/build-initial-values'
import Steps from '../../components/steps'
import Question from '../../components/question/question.component'
import WbacWrapper from '../../components/wrapper/wrapper.component'
import { ValuationResponse, VehicleInformation } from '../../types'

import * as styles from './valuation-update.module.css'

const ValuationUpdateComponent: React.FC<any> = ({ location, navigate, path }) => {
  const { token: storageToken } = Storage.get(Storage.StorageKeys.wbac)

  const valuation: ValuationResponse = location.state.valuation
  const vehicleInformation: VehicleInformation = location.state.vehicleInformation
  const { journey } = valuation

  if (!location.state || !location.state.vehicleInformation || !location.state.valuation) {
    setTimeout(() => navigate('/sell'))

    return null
  }

  const initialValues: any = {
    ...buildInitialValues(journey),
    damages: valuation.damages,
  }

  const getValuation = (formData: any): Promise<any> => {
    const { damages } = formData
    const valuationParameterDictionary = { ...formData }

    // here we remove damages as it should be sent in a seperate param to the API
    delete valuationParameterDictionary.damages

    const requestData = {
      quoteId: vehicleInformation.quoteId,
      quoteGuid: vehicleInformation.quoteGuid,
      valuationParameterDictionary,
      journeyName: 'AllAttributes',
      journeyVariant: null,
      damages,
      save: true,
    }

    return new Promise((resolve) =>
      WbacService.post('/valuations', requestData, { headers: { Authorization: `JWT ${storageToken}` } })
        .then(({ data }) => data)
        .then((valuationResponse) => {
          const options = { state: { vehicleInformation, valuation: valuationResponse } }

          navigate('/sell/valuation/view', options)
        })
        .catch((e) => resolve({ [FORM_ERROR]: e.message })),
    )
  }

  const assumptionsPage = journey.journeyPages[0]
  const [pageDisplayContent] = assumptionsPage.pageDisplayContent
  const assumptionsPanelTitle = pageDisplayContent.pageTitle || pageDisplayContent.pageDescription
  const questions = assumptionsPage.pageQuestions

  return (
    <>
      <SEO noIndex={true} />
      <WbacWrapper>
        <Steps page={path} />
        <Form
          onSubmit={getValuation}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} className={styles.main} name="updateValuation">
              <Panel title={assumptionsPanelTitle}>
                <div className={styles.fields}>
                  {questions.map((question) => (
                    <Question key={question.questionParameterId} question={question} />
                  ))}
                </div>
              </Panel>
              <Damage valuation={valuation} />
              <Primary type="submit" isFullWidth={true} isLoading={submitting} oxford={true}>
                Update valuation
              </Primary>
            </form>
          )}
        />
      </WbacWrapper>
    </>
  )
}

export default ValuationUpdateComponent
